<template>
    <div class="map_select">
        <div class="map_select_address_btn" @click="selectMap()">
            <span v-if="!selectAddress.city" style="color:#A6AEC1">{{placeholder}}</span>
            <span v-if="selectAddress.city" style="color:#606266">{{selectAddress.province}}{{selectAddress.city}}{{selectAddress.district}}</span>
            <img src="../assets/icon_xiala.png" alt="">
        </div>
        <el-dialog
                :visible.sync="mapVisible"
                :show-close="false"
                center
                width="920px"
                :before-close="handleClose">
                <div style="color:#ff6666">提示：输入地址后，需要点击地图上的标记点，城市和地址会显示到下方</div>
                <div class="map_select_address_select">
                    <div>您所选的城市是：{{selectName}}</div>
                    <div style="margin-left:20px">您所选的地点是：{{address}}</div>
                </div>
                <div :id="placeholder" class="map_select_address"></div>
                <div :id="'myPageTop'">
                    <table>
                        <tr>
                            <td>
                                <label>请输入关键字：</label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input :id="'tipinput' + placeholder"/>
                            </td>
                        </tr>
                    </table>
                </div>
                <div style="text-align:center">
                    <el-button style="margin-top:20px;width:104px;" type="primary" @click="submitMap">确认</el-button>
                </div>
        </el-dialog>
    </div>
   
</template>

<script>
/***
 * 组件说明
 * placeholder是未选择地址的时候显示内容
 * selectMap是选择地址后的回调函数,由于详细地址可以修改且不在组件内部，所以此处不适用双向绑定，而使用回调函数
 *  */ 
import AMap from 'AMap'
let map;
export default {
    props:["placeholder","selectForm",'disabled'],
   data (){
       return {
           selectName:'',
           lngLat:{},
           address:'',
           mapVisible:false,
           selectAddress:{},
           selectAddressCopy:{},
           marker:null
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       selectMap(){
           if(this.disabled){
               return
           }
           this.mapVisible = true;
           let _this = this;
           this.$nextTick(() => {
                this.mapInit();
                this.selectAddressCopy = JSON.parse(JSON.stringify(this.selectAddress));
                //更改map中心点
                if(this.selectAddress.latitude && this.selectAddress.longitude){
                    console.log(this.selectAddress);
                    map.setZoomAndCenter(15,[parseFloat(this.selectAddress.longitude), parseFloat(this.selectAddress.latitude)]);  
                    console.log([parseFloat(this.selectAddress.longitude), parseFloat(this.selectAddress.latitude)]);
                    this.marker = new AMap.Marker({
                        position: [parseFloat(this.selectAddress.longitude), parseFloat(this.selectAddress.latitude)],
                        offset: new AMap.Pixel(-10, -10)
                    });
                    map.add(this.marker);
                }
                
            });
       },
       handleClose(){
           this.mapVisible = false;
           this.selectAddress = JSON.parse(JSON.stringify(this.selectAddressCopy));
           this.selectName = this.selectAddress.province + this.selectAddress.city + this.selectAddress.district;
           this.address = this.selectAddress.detalied_address;
           map = null;
       },
       submitMap(){
           this.selectAddress = {
               lng:this.lngLat.lng,
               lat:this.lngLat.lat,
               city:this.selectName,
               address:this.address,
               province:this.province,
               city:this.city,
               district:this.district
           }
           this.mapVisible = false;
           map = null;
           this.$emit('selectMap',this.selectAddress);
       },
        //如果有地址，反填处理    
       initAddress(data){
           this.selectName = data.province + data.city + data.district;
           this.address = data.detalied_address;
           this.selectAddress = data;
       },
       mapInit(){
                let _this = this;
                map = new AMap.Map(this.placeholder, {
                    resizeEnable: true, //是否监控地图容器尺寸变化
                    zoom:15, //初始化地图层级
                });
                //输入提示
                var autoOptions = {
                    input: "tipinput" + this.placeholder
                };
                var auto = new AMap.Autocomplete(autoOptions);
                var placeSearch = new AMap.PlaceSearch({
                    map: map
                });  //构造地点查询类
                AMap.event.addListener(auto, "select", select);//注册监听，当选中某条记录时会触发
                function select(e) {
                    placeSearch.setCity(e.poi.adcode);
                    placeSearch.search(e.poi.name);  //关键字查询查询
                    // 清楚mark点
                    map.remove(_this.marker);
                    _this.marker = null;
                    // _this.marker.setMap(null);
                }
                AMap.event.addListener(placeSearch,'markerClick',function(e){
                    _this.selectName = e.data.pname + e.data.cityname + e.data.adname;
                    _this.province =  e.data.pname;
                    _this.city =  e.data.cityname;
                    _this.district =  e.data.adname;
                    _this.address = e.data.address;
                    _this.lngLat = {
                        lng:e.data.location.lng,
                        lat:e.data.location.lat
                    }
                });
       }
   },
   created() {

   },
   mounted() {
       
       
   }
}
</script>

<style scoped lang='less'>
.map_select{
    /deep/ .el-dialog__header{
        display: none;
    }
}
.map_select_address_btn{
    width:100%;
    height: 42px;
    line-height: 42px;
    border:1px solid #DCDFE6;
    position: relative;
    padding-left:16px;
    font-size: 14px;
    cursor: pointer;
    img{
        width:20px;
        position: absolute;
        right:10px;
        top: 11px;
    }
}
.map_select_address{
    width:870px;
    height: 500px;
    position: relative;
}
#myPageTop{
    position: absolute;
    top:80px;
    right:40px;
    z-index: 1000000;
    background:#fff;
    padding: 10px 20px;
}
.amap-sug-result{
    z-index: 10001!important;
}
.map_select_address_select{
    font-size: 20px;
    font-weight: 500;
    display: flex;
    margin-bottom:20px
}
</style>



// WEBPACK FOOTER //
// src/components/mapSelectAddress.vue